import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { AddCartNonMatchingProductFormValues } from "../types";
import { useTranslation } from "react-i18next";

export interface NameFormInputProps {}

export const NameFormInput = ({}: NameFormInputProps) => {
  const { control, watch } =
    useFormContext<AddCartNonMatchingProductFormValues>();
  const { t } = useTranslation("pos");

  return (
    <View>
      <Label label={t("form.name.label")}></Label>
      <Controller
        name="name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.name.placeholder")}
          />
        )}
      />
    </View>
  );
};
